<router-outlet />
<app-pwa-install-banner />
